import React from 'react';
import { Query } from 'react-apollo';
import { NavItem, Nav, NavDropdown, Grid, Row } from 'react-bootstrap';
import { Category } from '../Skeleton';
import { addToDataLayerGTM } from '../../utils/addToDataLayerGTM';
import ErrorModal from '../Modal/ErrorModal';

// Utilizado no componente Trail.jsx e Courses.jsx

const Categories = ({
  handleClickSubCategoriesGTM,
  client,
  category,
  subcategory,
  href,
}) => (
  <Grid fluid>
    <Row>
      <div className="contentMenu">

        <Query
          client={client}
          query={category}
        >
          {({ loading, error, data }) => {
            if (loading) return <Category />;
            if (error) {
              // Google Tag Manager
              addToDataLayerGTM({
                'event': 'erro',
                'descricao': 'erro ao buscar categorias'
              });
              return <ErrorModal />;
            };

            if (!data.category_collections.categories) {
              return (<div>(Vazio)</div>);
            }

            return (
              <Nav>

                {data.category_collections.categories.length ? <NavItem
                  data-gtm-type="click"
                  data-gtm-clicktype="submenu"
                  data-gtm-name="Todos"
                  href={href}>Todos</NavItem> : ''}

                {data.category_collections.categories.map((categ) => (

                  <NavDropdown
                    key={categ.title}
                    eventKey={2}
                    title={categ.title}
                    id="basic-nav-dropdown-right"
                  >
                    <Query
                      client={client}
                      query={subcategory}
                      variables={{ parent_id: categ.id }}
                    >
                      {({ loading, error, data }) => {
                        if (loading) return <div>Carregando...</div>;
                        if (error) {
                          // Google Tag Manager
                          addToDataLayerGTM({
                            'event': 'erro',
                            'descricao': 'erro ao buscar subcategorias'
                          });
                          return <ErrorModal />;
                        };

                        if (!data.category_collections) {
                          return (<div> (Vazio) </div>);
                        }

                        return data.category_collections.categories.map((sub_categ) => (
                          <NavItem
                            key={sub_categ.title}
                            data-gtm-type="click"
                            data-gtm-clicktype="submenu"
                            data-gtm-name={sub_categ.title}
                            onClick={() => handleClickSubCategoriesGTM(categ.title, sub_categ.title)}
                            eventKey={sub_categ.id}
                            href={href + sub_categ.id}>{sub_categ.title}</NavItem>
                        ));
                      }}
                    </Query>
                  </NavDropdown>

                ))}
              </Nav>
            )
          }}
        </Query>

      </div>
    </Row>
  </Grid>
);

export default Categories;



// WEBPACK FOOTER //
// ./src/components/CategoriesButtons/index.jsx